import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b38cbd94")

_pushScopeId("data-v-b38cbd94")
const _hoisted_1 = { class: "spark-docs-ad-popup" }
const _hoisted_2 = { class: "spark-docs-ad-popup__content" }
const _hoisted_3 = { class: "spark-docs-ad-popup__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_spark_docs_ad_popup_contacts = _resolveComponent("spark-docs-ad-popup-contacts")!
  const _component_spark_docs_ad_popup_form = _resolveComponent("spark-docs-ad-popup-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_spark_docs_ad_popup_contacts),
        _createVNode(_component_spark_docs_ad_popup_form, {
          disabled: _ctx.state.is_loading,
          completed: _ctx.state.is_completed,
          onClose: _ctx.onClose,
          onSubmit: _ctx.onSubmit
        }, null, 8, ["disabled", "completed", "onClose", "onSubmit"])
      ])
    ])
  ]))
})